
export function isClosable(bankInfo){
    var balance = parseInt(bankInfo.account.available_balance.slice(1));
    if(bankInfo.account.account_source!=="UN")
        return [false, "Cannot close external accounts."];
    if(bankInfo.account.status==="Closed")
        return [false, "Account is already closed."];
    if(balance!==0)
        return [false, "Cannot close account until balance is $0.00."];
    return [true, "OK"];
}